  import qs from 'qs'

export const queryJournalsPage = (locale: QueryLocaleString) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      fields: [
        'richText',
        'title',
      ],
      populate: {
        ...queryFragmentSeo,
        ...queryFragmentEducationEntries,
        ...queryFragmentExhibitionEntries,
        ...queryFragmentProjectEntries,
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `journals-page?${query}`
}
